import React, { useCallback } from 'react';
import { Serie } from '@nivo/line';
import { Flex, Circle, Stack, Text } from '@tapresearch/ui/components';

interface LineChartLegendProps {
  series: Serie[];
  colors: string[];
  direction: 'row' | 'column';
  visiblePoints: number[];
  onItemClick: (idx: number) => void;
}
export const LineChartLegend = ({
  series,
  colors,
  direction,
  visiblePoints,
  onItemClick,
}: LineChartLegendProps) => {
  const onItemClickCallback = useCallback(
    (e) => {
      const { seriesIndex } = e.currentTarget?.dataset;
      if (seriesIndex !== undefined) onItemClick(+seriesIndex);
    },
    [onItemClick]
  );

  if (!series.length) return null;

  return (
    <Stack
      data-testid="line-chart-legend"
      spacing={1}
      alignItems="flex-start"
      direction={direction}
      ml={12}
      pt={2}
      pl={4}
      pb={4}
      mb={10}
    >
      {series.map((answer, i) => {
        const isVisible = !visiblePoints.length || visiblePoints.includes(i);
        return (
          <Flex
            key={`answer-${i}`}
            data-testid={
              isVisible ? 'legend-item-visible' : 'legend-item-hidden'
            }
            data-series-index={i}
            onClick={onItemClickCallback}
            {...{
              role: 'button',
              align: 'center',
              p: 2,
              rounded: 'md',
              transitionProperty: 'common',
              transitionDuration: 'normal',
              color: !isVisible ? 'gray.300' : 'gray.800',
              _hover: {
                bg: 'gray.50',
              },
            }}
          >
            <Circle
              as={Flex}
              alignItems="center"
              boxSize={3}
              bg={!isVisible ? 'gray.100' : colors[i]}
            />
            <Text ml={2}>{answer.id}</Text>
          </Flex>
        );
      })}
    </Stack>
  );
};
